export type LocationRoleVo = 'loading' | 'unloading' | 'both';

export const LocationRoleLabels: Record<LocationRoleVo, string> = {
  loading: '積地',
  unloading: '降地',
  both: '両方',
};

export const LocationRoleOptions: LocationRoleVo[] = ['loading', 'unloading', 'both'];
